import React, { useEffect, useRef } from "react";
import Icon from "../icon/Icon";
import { Pagination, PaginationLink, PaginationItem,Card } from "reactstrap";
import { Block } from "../block/Block";

const PaginationEs = ({ itemPerPage, totalItems, paginate, currentPage, EmploymentRefId, UserId, MonthId, YearId, ToYearId, ToMonthId, setload, setStatee, setmodal }) => {
  const pageNumbers = [];

    const getdata = async () => {
        const sendData = {

            EmploymentRefId: Number(EmploymentRefId),
            UserId: Number(UserId),
            MonthId: Number(MonthId),
            YearId: Number(YearId),
            ToYearId: Number(ToYearId),
            ToMonthId: Number(ToMonthId)
        }
        console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/ES3MIS2', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    console.log("Im called")
                    console.log(data)
                    /*const flattenedData = data.map((item) => {
                        return item.eSdata.map((eSdata) => {
                            return {
                                eSdata,
                                item
                            };
                        });
                    });
                    const flattenedArray = flattenedData.flat()
                    console.log(flattenedArray)
                    setStatee(flattenedArray)*/
                    if (data.length === 0) {
                        setmodal(false)

                    }
                    setload(true)
                    setmodal(false)

                })


    };
  const myRef = useRef(0)
    useEffect(() => {
        var mainid = document.getElementById(currentPage)
        if (currentPage !== 1) {
            mainid.scrollIntoView()
        }
        getdata()
    }, [currentPage])

  for (let i = 1; i <= Math.ceil(totalItems / itemPerPage); i++) {
    pageNumbers.push(i);
  }
  
    const nextPage = () => {
        getdata()
    paginate(currentPage + 1);
  };

    const prevPage = () => {
    paginate(currentPage - 1);
  };

    return (
        <Block >
            <Pagination aria-label="Page navigation example" >
                <PaginationItem disabled={currentPage - 1 === 0 ? true : false}>
                    <PaginationLink
                        className="page-link-prev"
                        onClick={(ev) => {
                            ev.preventDefault();
                            prevPage();
                        }}
                        href="#prev"
                    >
                        <Icon name="chevrons-left" />
                        <span>Prev</span>
                    </PaginationLink>
                </PaginationItem>

                <div style={{ overflowY: 'scroll' }}>
                    <Card className="card-bordered card-stretch">
                        <Pagination aria-label="Page navigation example" >
                            {pageNumbers.map((item) => {
                                return (
                                    <PaginationItem ref={myRef} className={currentPage === item ? "active" : ""} key={item} id={item}>
                                        <PaginationLink
                                            tag="a"
                                            href="#pageitem"
                                            onClick={(ev) => {
                                                ev.preventDefault();
                                                paginate(item);
                                            }}
                                        >
                                            {item}
                                        </PaginationLink>

                                    </PaginationItem>
                                );
                            })}

                            
                        </Pagination>

                    </Card>
                </div>

                <PaginationItem disabled={pageNumbers[pageNumbers.length - 1] === currentPage}>
                    <PaginationLink
                        className="page-link-next"
                        onClick={(ev) => {
                            ev.preventDefault();
                            nextPage();
                        }}
                        href="#next"
                    >
                        <span>Next</span>
                        <Icon name="chevrons-right" />
                    </PaginationLink>
                </PaginationItem>
            </Pagination>
            
        </Block>
  );
};
export default PaginationEs;
